import classNames from 'classnames';
import { useMemo } from 'react';

import { useResizeCounter } from '../../../hooks';

import useStyles from './styles';
import ILayoutWithSidebar from './types';

function LayoutWithSidebar({
  header,
  main,
  sidebar,
  sidebarSize = '480px',
  headerClassName,
  mainClassName,
  mainContentClassName,
  sidebarClassName,
  rootClassName,
  leftSidebar,
  leftSidebarClassName,
}: ILayoutWithSidebar) {
  const classes = useStyles({ sidebarSize });
  const resizeCount = useResizeCounter();
  const layoutContent = useMemo(() => {
    return (
      <>
        {header && (
          <header className={classNames(classes.header, headerClassName)}>{header}</header>
        )}
        <div className={classes.body}>
          {leftSidebar && (
            <aside className={classNames(classes.sidebar, leftSidebarClassName)}>
              <div className={classes.sidebarContent}>{leftSidebar}</div>
            </aside>
          )}

          <div className={classNames(classes.main, mainClassName)}>
            <div className={classNames(classes.mainContent, mainContentClassName)}>{main}</div>
          </div>
          {sidebar && (
            <aside className={classNames(classes.sidebar, sidebarClassName)}>
              <div className={classes.sidebarContent}>{sidebar}</div>
            </aside>
          )}
        </div>
      </>
    );
  }, [
    classes.body,
    classes.header,
    classes.main,
    classes.mainContent,
    classes.sidebar,
    classes.sidebarContent,
    header,
    headerClassName,
    main,
    mainClassName,
    mainContentClassName,
    sidebar,
    sidebarClassName,
  ]);

  return (
    <div className={classNames(classes.root, rootClassName)}>
      {layoutContent}
      {resizeCount % 2 === 1 ? <div /> : null}
    </div>
  );
}

export default LayoutWithSidebar;
